<ng-template #locationRef let-location let-showstack="showStack" let-type="type">
  <zui-routing-location-item
    pathTextAlign="right"
    class="c-http-routing-item-locations"
    disableLink
    showDomainPlaceholder
    [serviceStackName]="location?.serviceStackInfo?.serviceStackName"
    [serviceStackId]="location?.serviceStackId"
    [type]="type"
    [port]="location?.port"
    [path]="location?.path">
  </zui-routing-location-item>
</ng-template>

<ng-template #locationSettingsButton let-location="location">
  <button
    type="button"
    [matTooltip]="translations().settingsTooltip"
    [matTooltipClass]="'c-zerops-tooltip'"
    [matTooltipPosition]="'above'"
    (click)="settingsClicked.emit(location.path)"
    class="__location-settings-button"
    [class.is-active]="hasActiveConfig(location)"
    mat-icon-button>
    <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
    <span class="__location-setting-button_status"></span>
  </button>
</ng-template>

@if (!hideOutOfSync() && !data().isSynced) {
  <div class="__out-of-sync">
    @if (!data().isSynced && !data().deleteOnSync && !!data().lastSync) {
      <div class="__out-of-sync_update">
        <span>Publish changes to Propagate Updates</span> <mat-icon class="__out-of-sync_icon">sync</mat-icon>
      </div>
    }
    @if (!data().isSynced && data().deleteOnSync && !!data().lastSync) {
      <div class="__out-of-sync_deletion">
        <span>Publish Changes to Confirm Deletion</span> <mat-icon class="__out-of-sync_icon">delete_outline</mat-icon>
      </div>
    }
    @if (!data().isSynced && !data().lastSync) {
      <div class="__out-of-sync_new">
        <span>Publish Changes to Add Domain Access</span> <mat-icon class="__out-of-sync_icon">add</mat-icon>
      </div>
    }
  </div>
}

<div
  [class.has-settings]="showSettings()"
  class="__grid">

  <div>
    <div class="__domains">
      @for (domain of data().domains; track trackByDomain($index, domain)) {
        <div>
          <span
            class="__domain"
            [class.is-not-dns-active]="domain.dnsCheckStatus === dnsStatuses.Failed"
            [class.is-active]="domain.dnsCheckStatus === dnsStatuses.Ok && (domain.sslStatus === sslStatuses.Inactive || domain.deployedSslCertificate)">

          <!-- Domain header - NOT clickable (just displays name) -->
          <div class="__domain-header">
            <h4 class="__domain_name">
              <span class="__domain_name-text">{{ domain.domainName }}</span>
            </h4>

            <!-- Status Badges - now individually clickable -->
            <div class="__domain-badges">

              <!-- DNS Badge - always shown, opens DNS popover -->
              <button
                type="button"
                class="__domain-badge __domain-badge--clickable"
                [class.is-active]="domain.dnsCheckStatus === dnsStatuses.Ok"
                [class.is-processing]="domain.dnsCheckStatus === dnsStatuses.Pending || domain.dnsCheckStatus === dnsStatuses.Checking"
                [class.is-error]="domain.dnsCheckStatus === dnsStatuses.Failed"
                #dnsBadgeAnchor="dynamicPopAnchor"
                [zuiDynamicPopAnchor]="sharedBadgePopover()"
                (click)="openBadge('dns', domain, dnsBadgeAnchor)">
                <mat-icon class="__domain-badge_icon">
                  {{ domain.dnsCheckStatus === dnsStatuses.Ok ? 'check' : (domain.dnsCheckStatus === dnsStatuses.Failed ? 'priority_high' : 'schedule') }}
                </mat-icon>
                <span class="__domain-badge_label">DNS</span>
              </button>

              <!-- SSL Badge - shown when SSL is active, opens SSL popover -->
              @if (showSslBadge(domain)) {
                <button
                  type="button"
                  class="__domain-badge __domain-badge--clickable"
                  [class.is-active]="domain.deployedSslCertificate"
                  [class.is-processing]="!domain.deployedSslCertificate"
                  #sslBadgeAnchor="dynamicPopAnchor"
                  [zuiDynamicPopAnchor]="sharedBadgePopover()"
                  (click)="openBadge('ssl', domain, sslBadgeAnchor)">
                  <mat-icon
                    class="__domain-badge_icon"
                    [class.__domain-badge_icon--waiting]="domain.sslStatus === sslStatuses.WaitingForDns && domain.deployedSslCertificate">
                    {{ (domain.deployedSslCertificate && domain.sslStatus !== sslStatuses.WaitingForDns) ? 'verified' : 'hourglass_empty' }}
                  </mat-icon>
                  <span class="__domain-badge_label">SSL</span>
                </button>
              }

              <!-- CDN Badge - shown when CDN is active, opens CDN popover -->
              @if (showCdnBadge(domain)) {
                <button
                  type="button"
                  class="__domain-badge __domain-badge--clickable"
                  [class.is-active]="domain.cdnStatus === cdnStatuses.Active"
                  [class.is-processing]="domain.cdnStatus === cdnStatuses.BeingInstalled || domain.cdnStatus === cdnStatuses.BeingDisabled"
                  #cdnBadgeAnchor="dynamicPopAnchor"
                  [zuiDynamicPopAnchor]="sharedBadgePopover()"
                  (click)="openBadge('cdn', domain, cdnBadgeAnchor)">
                  <mat-icon class="__domain-badge_icon">{{ domain.cdnStatus === cdnStatuses.Active ? 'check' : 'hourglass_empty' }}</mat-icon>
                  <span class="__domain-badge_label">CDN</span>
                </button>
              }

            </div>
          </div>

        </span>
      </div>
    }
    </div>
  </div>

  <div>
    <div class="__locations-wrap">

      <!-- main locations -->
      @for (location of stackLocations(); track trackBy($index, location)) {
        <div class="__locations-item-wrap   __locations-item-wrap--main">

          <ng-container
            *ngTemplateOutlet="locationRef;
            context: { $implicit: location, type: 'stack' }"
          />

          @if (showSettings()) {
            <ng-container
              *ngTemplateOutlet="locationSettingsButton; context: { location: location }" />
          }

        </div>
      }

      <!-- other locations -->
      @for (location of otherLocations(); track trackBy($index, location)) {
        <div class="__locations-item-wrap">

          <ng-container
            *ngTemplateOutlet="locationRef;
            context: { $implicit: location, type: 'other' }"
          />

          @if (showSettings()) {
            <ng-container
              *ngTemplateOutlet="locationSettingsButton; context: { location: location }" />
          }
        </div>
      }

    </div>
  </div>

</div>
